import css from 'styled-jsx/css';

const styles = css.global`.ctn {
  box-sizing: border-box;

  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
}

.ctn.ctn-f-mb {
  padding-right: 0px;
  padding-left: 0px;
  max-width: unset;
}

.ctn.ctn-rm-p {
  padding-right: 0;
  padding-left: 0;
}

@media (min-width: 576px) {
  .ctn {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .ctn {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .ctn,
  .ctn.ctn-f-mb {
    max-width: 960px;
  }

  .ctn.ctn-f-mb {
    padding-right: 15px;
    padding-left: 15px;
  }

  .ctn.ctn-e-p {
    padding-right: 30px;
    padding-left: 30px;
  }
}

@media (min-width: 1200px) {
  .ctn,
  .ctn.ctn-f-mb {
    max-width: 1140px;
  }
}

@media (min-width: 1400px) {
  .ctn,
  .ctn.ctn-f-mb {
    max-width: 1238px;
  }
}

amp-script {
  opacity: 1;
}
`;

export default styles;